"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerUIProvider = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const usePrimaryColor_1 = require("../hooks/usePrimaryColor");
const theme_1 = require("../theme");
const GlobalStylesProvider_1 = require("./GlobalStylesProvider");
const HackerUIProvider = ({ theme = theme_1.defaultHackerUITheme, children, }) => {
    return (react_2.default.createElement(react_1.ChakraProvider, { theme: theme },
        react_2.default.createElement(react_1.ColorModeScript, { initialColorMode: theme.config.initialColorMode }),
        react_2.default.createElement(usePrimaryColor_1.PrimaryThemeColorProvider, null,
            react_2.default.createElement(GlobalStylesProvider_1.GlobalStylesProvider, null, children))));
};
exports.HackerUIProvider = HackerUIProvider;
//# sourceMappingURL=HackerUIProvider.js.map